const TOPICS = [
  { label: '韩漫完结推荐', heat: '9.8w' },
  { label: '日漫新番速递', heat: '8.5w' },
  { label: '国漫崛起佳作', heat: '7.2w' },
  { label: '恋爱甜宠漫画', heat: '6.9w' },
  { label: '奇幻异世界', heat: '6.3w' },
  { label: '热血战斗番', heat: '5.8w' },
  { label: '悬疑推理向', heat: '5.1w' },
  { label: '搞笑日常番', heat: '4.7w' },
  { label: '下拉式阅读', heat: '4.2w' },
  { label: '免费全集漫画', heat: '3.9w' },
  { label: '治愈系漫画', heat: '3.4w' },
];

export default function TopicsSection() {
  return (
    <section id="topics" className="py-16 md:py-20 bg-background-100">
      <div className="px-4 md:px-6 max-w-[1280px] mx-auto">
        <div className="text-center mb-10">
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-[560px] mx-auto">
            探索当下漫迷最关注的话题标签，发现你的兴趣领域
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-3">
          {TOPICS.map((topic, idx) => (
            <a
              key={topic.label}
              href="#index"
              onClick={(e) => {
                e.preventDefault();
                document.querySelector('#index')?.scrollIntoView({ behavior: 'smooth' });
              }}
              className="group inline-flex items-center gap-2 px-4 py-2.5 rounded-full bg-background-50 border border-background-200/70 hover:border-primary-300 hover:bg-primary-50 transition-all duration-200 cursor-pointer whitespace-nowrap"
              style={{ animationDelay: `${idx * 0.05}s` }}
            >
              <span className="text-sm text-foreground-700 group-hover:text-primary-600 font-medium">
                {topic.label}
              </span>
              <span className="text-xs text-accent-600 bg-accent-100 px-2 py-0.5 rounded-full font-medium">
                {topic.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}